import * as React from 'react'

import { useLocalization } from '../../../../app/_providers/LocalizationProvider.client'
import { useTranslation } from '../../../../app/_providers/TranslationProvider.client'
import { EmbroideryModalService } from '../../../../containers/EmbroideryService/EmbroideryModalService'
import { trackEvent } from '../../../../lib/analytics'
import { intlPrettyCurrency } from '../../../../lib/utils'

import { Body, Button, LeftButtonWrapper, RightButtonWrapper } from './styles'

export const SubmissionButtons: React.FC<{
  onReset(): void
  heapCtaAction?: string
  disableReset?: boolean
  displayPrice?: number | undefined
}> = ({ onReset, disableReset, heapCtaAction = 'form submit', displayPrice }) => {
  const { embroidery: fixtures } = useTranslation()
  const { region, locale } = useLocalization()
  const { withPricing } = EmbroideryModalService.useContainer()

  const price = displayPrice
    ? intlPrettyCurrency({
        unit: 'cents',
        value: displayPrice,
        region: region,
        locale: locale,
        truncateTrailingZeros: true,
      })
    : undefined

  const isDisabled = !price || price === '0'

  return (
    <Body>
      <LeftButtonWrapper>
        <Button
          aria-label={fixtures.modal.forms.submissionButtons.resetCta}
          onClick={onReset}
          variant='ghost'
          type='button'
          aria-disabled={disableReset}
          {...trackEvent({
            category: 'embroidery',
            action: 'reset form',
          })}
        >
          {fixtures.modal.forms.submissionButtons.resetCta}
        </Button>
      </LeftButtonWrapper>
      <RightButtonWrapper>
        {/* TODO: Replace button with anchor tag or use an actual click function. */}
        <Button
          aria-label={fixtures.modal.forms.submissionButtons.submitCta}
          onClick={() => null}
          type='submit'
          aria-disabled={isDisabled}
          {...trackEvent({
            category: 'embroidery',
            action: heapCtaAction,
          })}
        >
          {fixtures.modal.forms.submissionButtons.submitCta}{' '}
          {Boolean(!isDisabled && price && withPricing) && ` +${price}`}
        </Button>
      </RightButtonWrapper>
    </Body>
  )
}
